import { render } from "./reviewSlide.vue?vue&type=template&id=50ac15a9&scoped=true"
import script from "./reviewSlide.vue?vue&type=script&lang=js"
export * from "./reviewSlide.vue?vue&type=script&lang=js"

import "./reviewSlide.vue?vue&type=style&index=0&id=50ac15a9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50ac15a9"]])

export default __exports__